import Deferred from "core/deferred";
export default function Element(selector, parent = document) {
  const element = selector instanceof HTMLElement ? selector : parent.querySelector(selector);
  if (element == null) throw `Could not create Element! (${selector}`;
  element.classList.add("element");
  function setVisible(visible) {
    if (visible) element.classList.remove("hidden");else element.classList.add("hidden");
  }
  function setSelected(selected) {
    if (selected) element.classList.add("selected");else element.classList.remove("selected");
  }
  function isEmpty() {
    return element.childNodes.length == 0;
  }
  function setOpacity(opacity) {
    element.style.opacity = opacity;
  }
  async function waitForTransitionEnd(property = "transform") {
    const deferred = new Deferred();
    element.addEventListener("transitionend", function handler(e) {
      console.log("transitionend", e.propertyName);
      if (e.propertyName === property) {
        element.removeEventListener("transitionend", handler);
        deferred.resolve();
      }
    });
    return deferred.promise;
  }
  return Object.assign(element, {
    setVisible,
    setSelected,
    setOpacity,
    isEmpty,
    waitForTransitionEnd
  });
}